module.exports = __webpack_public_path__ + "static/hooked-92f985c37dd5ba8b7dd8f4999d966bc8.jpg";